<template>
  <client-only>
    <div>
      <v-combobox
        v-model="model"
        item-text="NameInHebrew"
        :loading="isLoading"
        item-value="Code"
        :placeholder="!model ? displayUsersLocation : formLabel"
        :items="cities"
        :search-input.sync="search"
        solo
        background-color="transparent"
        outlined
        dense
        flat
        filled
        rounded
        clearable
        :menu-props="{
          contentClass: 'smart-combo scrollbar-17',
          maxHeight: '200',
        }"
     
      />
    </div>
  </client-only>
</template>

<script>
import debounce from 'lodash/debounce';
import { locationRules } from '@/lib/rules.js';
import { CITY_AUTO_COMPLETE } from '@/lib/api.js';

export default {
  props: {
    fieldClass: {
      type: String,
      required: false,
      default: 'dr-field',
    },

    currentLocation: {
      type: Object,
    },
  },
  data() {
    return {
      select: '',
      search: '',
      isLoading: false,
      cities: [],
      formLabel: 'ישוב',
      locationRules,
    };
  },

  computed: {
    normalizedLocation() {
      const normalLocation = {
        NameInHebrew: this.currentLocation.City,
        Code: this.currentLocation.CityId,
      };
      return normalLocation;
    },

    model: {
      get() {
        return this.currentLocation ? this.normalizedLocation : '';
      },
      set(val) {
        this.select = val;
      },
    },

    displayUsersLocation() {
      return this.currentLocation ? this.currentLocation.City : this.formLabel;
    },
  },

  watch: {
    search() {
      if (this.search) this.fetchPlaces(this.search);
    },
    select() {
      this.$emit('updateLocation', this.select);
    },
  },

  mounted() {
    // this.search='לא רלוונטי'
    this.fetchPlaces = debounce(this.fetchPlaces, 200);
  },

  methods: {
    fetchPlaces() {
      if (this.isLoading) return;
      this.isLoading = true;

      try {
        this.$axios
          .get(
            `${CITY_AUTO_COMPLETE}/?cityautocomplete=${this.search}&issmartagent=false`
          )
          .then((res) => {
            if (res.data.IsError) {
              throw res.data.Errors;
            }
            this.cities = res.data;
            this.isLoading = false;
          });
      } catch (error) {
        console.log('location field', error);
      }
    },
  },
};
</script>
